
import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Home, Briefcase, User } from 'lucide-react';
import { useSession } from '../context/SessionContext';

const NavBtn = ({ active, icon: Icon, label, onClick, count }: any) => (
    <button
        onClick={onClick}
        className={`
            flex flex-col items-center justify-center gap-0.5 
            transition-all relative flex-1 min-w-0
            py-2 px-1
            ${active ? 'text-blue-600' : 'text-slate-400'}
            hover:bg-slate-50 active:bg-slate-100
            touch-manipulation
        `}
        style={{ WebkitTapHighlightColor: 'transparent' }}
    >
        <Icon className="w-6 h-6 sm:w-5 sm:h-5" strokeWidth={active ? 2.5 : 2} />
        {count > 0 && (
            <span className="absolute top-0.5 right-1/4 bg-red-600 text-white text-[9px] font-bold w-4 h-4 rounded-full border-2 border-white flex items-center justify-center">
                {count}
            </span>
        )}
        <span className="text-[10px] sm:text-[9px] font-bold uppercase tracking-tight mt-0.5">
            {label}
        </span>
    </button>
);

export const UserLayout: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { myJobs } = useSession();

    const getActiveTab = (path: string) => {
        if (path.includes('/user/activity')) return 'activity';
        if (path.includes('/user/profile') || path.includes('/user/settings')) return 'profile';
        return 'home';
    };

    const activeTab = getActiveTab(location.pathname);
    const activityCount = myJobs.filter(j => j.status !== 'COMPLETED' && j.status !== 'CANCELLED').length;

    return (
        <div className="flex flex-col h-screen overflow-hidden bg-white dark:bg-slate-900 safe-top">
            <main className="flex-1 relative overflow-hidden flex flex-col min-h-0 pb-16 sm:pb-14 dark:bg-slate-900">
                <Outlet />
            </main>

            {/* Mobile Bottom Navigation - Fixed */}
            <nav
                className="
                    fixed bottom-0 left-0 right-0
                    bg-white dark:bg-slate-900 border-t border-slate-200 dark:border-slate-800
                    flex flex-row justify-around items-stretch
                    z-[9999]
                    shadow-[0_-2px_10px_rgba(0,0,0,0.08)]
                    h-auto min-h-[4rem] pb-[env(safe-area-inset-bottom)] sm:pb-0
                "
            >
                <NavBtn
                    active={activeTab === 'home'}
                    icon={Home}
                    label="Home"
                    onClick={() => navigate('/user/home')}
                />
                <NavBtn
                    active={activeTab === 'activity'}
                    icon={Briefcase}
                    label="Activity"
                    onClick={() => navigate('/user/activity')}
                    count={activityCount}
                />
                <NavBtn
                    active={activeTab === 'profile'}
                    icon={User}
                    label="Profile"
                    onClick={() => navigate('/user/profile')}
                />
            </nav>
        </div >
    );
};
